import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { duplicateEvent, searchEvents } from './credit-service';

const getDuplicateEventSearchBaseQueryKey = orgId => [
  'organization',
  orgId,
  'duplicate-event-search',
];

const duplicateEventSearchOptions = (orgId, search, enabled) => ({
  queryKey: [...getDuplicateEventSearchBaseQueryKey(orgId), search],
  queryFn: () => searchEvents(search, orgId),
  enabled,
  keepPreviousData: true,
  select: results => results.map(({ id, name, shortcode: code }) => ({ id, code, name })),
});

export const useDuplicateEventSearch = (orgId, search, enabled = true) =>
  useQuery(duplicateEventSearchOptions(orgId, search, enabled));

export const useCreateDuplicateEvent = orgId => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organization', orgId, 'duplicate-event'],
    mutationFn: ({ data, duplicationConfig }) => duplicateEvent(data, orgId, duplicationConfig),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: getDuplicateEventSearchBaseQueryKey(orgId) }),
  });
};
